import { defineMessages } from 'react-intl';

export default defineMessages({
  totalSupply: { defaultMessage: 'Total Supply' },
  totalStakedSupply: { defaultMessage: 'Total Staked' },
  totalStakedPercentage: { defaultMessage: 'Staked Percentage' },
});
